import { render, staticRenderFns } from "./pdf-georef-fields.vue?vue&type=template&id=5bc152be&scoped=true&"
import script from "./pdf-georef-fields.vue?vue&type=script&lang=js&"
export * from "./pdf-georef-fields.vue?vue&type=script&lang=js&"
import style0 from "./pdf-georef-fields.vue?vue&type=style&index=0&id=5bc152be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc152be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VExpandTransition,VIcon,VRow})
